import { Box, Typography, styled, Skeleton } from "@mui/material";
import { useState } from "react";
import GenerateReportDialog from "./generate-report-diaog";
import { useReportOptions } from "@/hooks/use-report-options";
import { getReportTypeMeta } from "../../data";

const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(2),
}));

const ReportCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 10,
  padding: theme.spacing(2),
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.02)"
      : theme.palette.grey[50],
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const IconBox = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: "50%",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.08)"
      : theme.palette.grey[200],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.secondary,
}));

const GenerateButton = styled("button")(({ theme }) => ({
  width: "100%",
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
  fontFamily: "inherit",
  border: "none",
  cursor: "pointer",
  padding: theme.spacing(1, 0),
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.08)"
      : theme.palette.grey[200],
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.12)"
        : theme.palette.grey[300],
  },
}));

const QuickGenerate = () => {
  const { types, isLoading } = useReportOptions();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activeType, setActiveType] = useState(null);

  const handleGenerateClick = (type) => {
    setActiveType(type);
    setDialogOpen(true);
  };

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h6" fontWeight={600} sx={{ fontSize: "1rem" }}>
          Quick Generate
        </Typography>

        <Grid>
          {isLoading
            ? Array.from({ length: 4 }).map((_, idx) => (
                <Skeleton
                  key={idx}
                  variant="rounded"
                  height={128}
                  sx={{ borderRadius: "10px" }}
                />
              ))
            : types.map((type) => {
                const meta = getReportTypeMeta(type);
                const Icon = meta.icon;
                return (
                  <ReportCard key={type}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                    >
                      <IconBox>
                        <Icon fontSize="small" />
                      </IconBox>
                      <Box>
                        <Typography variant="body2" fontWeight={600}>
                          {meta.label}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {meta.description}
                        </Typography>
                      </Box>
                    </Box>

                    <GenerateButton onClick={() => handleGenerateClick(type)}>
                      Generate
                    </GenerateButton>
                  </ReportCard>
                );
              })}
        </Grid>
      </Box>

      <GenerateReportDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        mode="create"
        initialType={activeType}
      />
    </>
  );
};

export default QuickGenerate;
